

import React from "react";
import "./Dhaba.css";

import amrik from "../../assets/amrik.jpg";
import giani from "../../assets/giani.jpg";
import pahalwan from "../../assets/pahalwan.jpg";
import pal from "../../assets/pal.jpg";
import gulshan from "../../assets/gulshan.jpg";
import haveli from "../../assets/haveli.jpg";
import kesar from "../../assets/kesar.jpg";
import zimidara from "../../assets/zimidara.jpg";
import chokhi from "../../assets/chokhi.jpg";
import bawarchi from "../../assets/bawarchi.jpg";
import rasraj from "../../assets/rasraj.jpg";
import sher from "../../assets/sher.jpg";
import lucky from "../../assets/lucky.jpg";
import sri from "../../assets/sri.jpg";
import desi from "../../assets/desi.jpg";
import bhole from "../../assets/bhole.jpg";
import kake from "../../assets/kake.jpg";
import truckers from "../../assets/truckers.jpg";
import chator from "../../assets/chator.jpg";
import highway from "../../assets/highway.jpg";
import sharma from "../../assets/sharma.jpg";
import shree_ram from "../../assets/shree_ram.jpg";
import bhojanalay from "../../assets/bhojanalay.jpg";
import tandoori from "../../assets/tandoori.jpg";
import sardarji from "../../assets/sardarji.jpg";
import meera from "../../assets/meera.jpg";
import food from "../../assets/food.jpg";
import desi_tandoor from "../../assets/desi_tandoor.jpg";




const dhabas = [
  {
    image:
      amrik,
    name: "Amrik Sukhdev Dhaba",
    address: "Murthal, Haryana",
  },
  {
    image:giani,
    name: "Giani Da Dhaba",
    address: "Dharampur, Himachal Pradesh",
  },
  {
    image:
      pahalwan,
    name: "Pahalwan Dhaba",
    address: "Katra, Jammu & Kashmir",
  },
  {
    image:
     pal,
    name: "Pal Dhaba",
    address: "Chandigarh, Punjab",
  },
  {
    image:
     gulshan,
    name: "Gulshan Dhaba",
    address: "Sonipat, Haryana",
  },
  {
    image:
      haveli,
    name: "Haveli Dhaba",
    address: "Karnal, Haryana",
  },
  {
    image:
     kesar,
    name: "Kesar Da Dhaba",
    address: "Amritsar, Punjab",
  },
  {
    image: zimidara,
    name: "Zimidara Dhaba",
    address: "Zirakpur, Punjab",
  },
  {
    image:
    chokhi,
    name: "Chokhi Dhani",
    address: "Jaipur, Rajasthan",
  },
  {
    image:
      bawarchi,
    name: "Bawarchi Dhaba",
    address: "Hyderabad, Telangana",
  },
  {
    image:
     rasraj,
    name: "Rasraj Dhaba",
    address: "Mumbai, Maharashtra",
  },
  {
    image:
      sher,
    name: "Sher-e-Punjab Dhaba",
    address: "Kolaghat, West Bengal",
  },
  {
    image:
      lucky,
    name: "Lucky Da Dhaba",
    address: "Vadodara, Gujarat",
  },
  {
    image:
      sri,
    name: "Sri Krishna Dhaba",
    address: "Bangalore, Karnataka",
  },
  {
    image:
      desi,
    name: "Desi Dhaba",
    address: "Pune, Maharashtra",
  },
  {
    image:
    bhole,
    name: "Bhole Nath Dhaba",
    address: "Lucknow, Uttar Pradesh",
  },
  {
    image: kake,
    name: "Kake Da Dhaba",
    address: "Connaught Place, Delhi",
  },
  {
    image:
      truckers,
    name: "Truckers Dhaba",
    address: "Surat, Gujarat",
  },
  {
    image:
     chator,
    name: "Chatori Gali Dhaba",
    address: "Bhopal, Madhya Pradesh",
  },
  {
    image:
     highway,
    name: "Highway Dhaba",
    address: "Udaipur, Rajasthan",
  },
  {
    image: sharma,
    name: "Sharma Dhaba",
    address: "Jaipur, Rajasthan",
  },
  {
    image:
      shree_ram,
    name: "Shree Ram Dhaba",
    address: "Kanpur, Uttar Pradesh",
  },
  {
    image: bhojanalay,
    name: "Sharma Bhojanalay",
    address: "Ajmer, Rajasthan",
  },
  {
    image:
      tandoori,
    name: "Punjab Tandoori Dhaba",
    address: "Navi Mumbai, Maharashtra",
  },
  {
    image:
     sardarji,
    name: "Sardarji Dhaba",
    address: "Indore, Madhya Pradesh",
  },
  {
    image:
     meera,
    name: "Meera Dhaba",
    address: "Raipur, Chhattisgarh",
  },
  {
    image:
     food,
    name: "Food Express Dhaba",
    address: "Gandhinagar, Gujarat",
  },
  {
    image:
     desi_tandoor,
    name: "Desi Tandoor Dhaba",
    address: "Ranchi, Jharkhand",
  },
];






const Dhaba = () => {
  return (
    <div className="dhaba-container">
      {dhabas.map((dhaba, index) => (
        <div className="dhaba-card" key={index} style={{ animationDelay: `${index * 0.1}s` }}>
          <img src={dhaba.image} alt={dhaba.name} className="dhaba-image" />
          <h3 className="dhaba-name">{dhaba.name}</h3>
          <p className="dhaba-address">{dhaba.address}</p>
        </div>
      ))}
    </div>
  );
};



  
export default Dhaba;
